import * as React from "react";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { findIconDefinition, IconLookup } from "@fortawesome/fontawesome-svg-core";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

import "./ReportStatusInfo.scss";

type Props = {
  variant?: "kickback" | "invoice";
  hideCancelled?: boolean;
};

export default function ReportStatusInfo(props: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const variant = props.variant ?? "kickback";
  const statuses = (variant === "invoice"
    ? AppSettings.invoiceReports.status
    : AppSettings.kickbackReportsStatusIcons
  ).filter(
    (status) => !props.hideCancelled || status.key !== 9,
  );
  const statusLabelKey =
    variant === "invoice" ? "invoiceReportList.statusTexts" : "kickback.status";

  return (
    <div className="report-status-info" aria-expanded={isOpen}>
      <button
        className="report-status-info__toggle"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="report-status-info__title">
          <FontAwesomeIcon icon={faCircleInfo} />
          {t("reportStatusInfo.title")}
        </span>
      </button>
      <div className="report-status-info__content" aria-hidden={!isOpen}>
        <div className="report-status-info__header">
          <div>
            <div className="report-status-info__heading">
              {t("reportStatusInfo.title")}
            </div>
            <p className="report-status-info__intro">
              {t("reportStatusInfo.description")}
            </p>
          </div>
          <button
            className="report-status-info__close"
            type="button"
            onClick={() => setIsOpen(false)}
          >
            {t("general.close")}
          </button>
        </div>
        <div className="report-status-info__grid">
          {statuses.map((status) => {
            const lookup: IconLookup = {
              prefix: "fas",
              iconName: status.icon as any,
            };
            return (
              <div className="report-status-info__item" key={status.key}>
                <FontAwesomeIcon
                  className="report-status-info__icon"
                  style={{ color: status.color }}
                  icon={findIconDefinition(lookup)}
                />
                <div>
                  <div className="report-status-info__label">
                    {t(`${statusLabelKey}.${status.key}`)}
                  </div>
                  <div className="report-status-info__text">
                    {t(`reportStatusInfo.${variant}.status.${status.key}`)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
